import { render, staticRenderFns } from "./SeleccionMetodoPago.vue?vue&type=template&id=5596a663&scoped=true"
import script from "./SeleccionMetodoPago.vue?vue&type=script&lang=ts"
export * from "./SeleccionMetodoPago.vue?vue&type=script&lang=ts"
import style0 from "./SeleccionMetodoPago.vue?vue&type=style&index=0&id=5596a663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5596a663",
  null
  
)

export default component.exports